import { styled } from '@mui/material';
import { Typography } from 'core/common/ui/ui-kit';

export const WrapperStyled = styled('div')`
  min-height: 300px;
  overflow-y: auto;
`;

export const TitleStyled = styled(Typography)`
  margin-bottom: 32px;
  text-align: center;
`;
